
import { Options, Vue } from "vue-class-component";
import address, { APIKEY }  from "@/setting";
import axios from "axios"
@Options({
  components: {},
})
export default class App extends Vue {


  beforeMount() {
    axios.interceptors.request.use((config)=> {
      const token = APIKEY;
      config!.headers!.apikey = token;
      config!.headers!.token = token;
      // config!.headers!.authorization = `Bearer ${this.$store.state.jwt}`;

      return config;
    });
  }
}
